import Vue from 'vue'
import toast from '@/components/toast'

Vue.use(toast)